import classNames from 'classnames/bind'
import FormControlWrapper from '../FormControlWrapper'

const Input = props => (
  <FormControlWrapper
    id={props.id}
    name={props.name}
    label={props.label}
    required={props.required}
    horizontal={props.horizontal}
    error={props.formComponent ? (props.touched ? props.error : '') : props.error}
    help={props.help}
    icon={props.icon}
    size={props.size}
    disabled={props.disabled}
  >
    <input
      id={props.id}
      type={props.type}
      value={props.value}
      className={classNames({
        'input': true,
        'is-static': props.isStatic,
        [`is-${props.size}`]: props.size,
        [props.className]: props.className
      })}
      style={props.style}
      name={props.name}
      autoComplete={props.autoComplete}
      maxLength={props.maxLength}
      onChange={props.handleChange}
      onPaste={props.onPaste}
      onBlur={props.onBlur}
      onFocus={props.onFocus}
      pattern={props.pattern}
      placeholder={props.placeholder}
      disabled={props.disabled}
      readOnly={props.isStatic}
    />
    {
      props.icon && props.iconType === 'material' &&
      <span className="icon is-small is-left">
        <i className={`mdi mdi-24px mdi-${props.icon}`} />
      </span>
    }
    {
      props.icon && props.iconType === 'fa' &&
      <span className="icon is-medium is-left">
        <span className="fa-stack has-text-centered">
          <i className={`${props.iconStyle} fa-${props.icon} fa-lg`} />
        </span>
      </span>
    }
  </FormControlWrapper>
)

Input.defaultProps = {
  disabled: false,
  touched: false,
  formComponent: false,
  type: 'text',
  size: 'small',
  iconType: 'material',
  iconStyle: 'fas'
}

export default Input



// WEBPACK FOOTER //
// ./components/uiLib/Input/Input.js